<template>
  <div id="subject-videos-body">
    <div
      v-for="item in newsList"
      :key="item.id"
      class="news-item"
      :style="{
        border:
          showBorder == 2
            ? '2px solid #FFF'
            : showBorder == 1
            ? '2px solid #000'
            : '0px',
      }"
      @click="goToDetail(item.id)"
    >
      <img :src="getImageURL(item.cover)" style="height: 98px; width: 100%" />
      <div
        class="textT"
        style="
          text-align: left;
          padding: 5px;
          background: #fff;
          margin-top: -5px;
        "
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
import request, {
  getCategoriesByType,
  getResourceNewsCon,
} from "@/utils/request";
import { getImageURL as _getImageURL } from "@/utils/zgly-utils.js";

export default {
  components: {},
  props: {
    newsList: {
      type: Array,
    },
    showBorder: {
      type: Number,
    },
  },
  data() {
    return {
      currentList: [],
      //   newsList: [],
      // 分页信息
      pageInfo: {
        total: 0,
        page: 1,
        size: 4,
      },
    };
  },
  mounted() {
    // this.pageInfo.total = this.$props.newsList.length;
    // this.listNews(this.pageInfo.page, this.pageInfo.size);
  },

  methods: {
    listNews(offset, size) {
      if (this.$props.newsList.length < offset * size) {
        this.currentList = this.$props.newsList.slice((offset - 1) * size);
      } else {
        this.currentList = this.$props.newsList.slice(
          (offset - 1) * size,
          size
        );
      }
    },
    textAdapt(val) {
      var txt = new RegExp("<.+?>", "g");
      txt = val.replace(txt, "");
      return txt.replace(/&nbsp;/gi, "");
    },
    pageChange() {
      this.listNews(this.pageInfo.page, this.pageInfo.size);
    },
    parseUrl(url) {
      let imgArr = url.split(",");
      if (typeof imgArr === "string") {
        imgArr = [imgArr];
      }
      imgArr.map((_) => {
        _ = this.getImageURL(_);
        return _;
      });
      return imgArr;
    },
    getImageURL(cover) {
      return _getImageURL(cover);
    },
    goToDetail(id) {
      this.$router.push({ path: `/video/player/${id}` });
    },
  },
};
</script>

<style lang="less" scope>
#subject-videos-body {
  width: 100%;
  margin: auto;
  margin-left: 10px;
  display: flex;
  flex-wrap: wrap;
  .news-item {
    margin-right: 10px;
    width: calc(50% - 10px);
    overflow: hidden;
    margin-top: 5px;
    cursor: pointer;
    .textT {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
